import { render, staticRenderFns } from "./Specific_m.vue?vue&type=template&id=4d7be5f8&scoped=true&"
import script from "./Specific_m.vue?vue&type=script&lang=js&"
export * from "./Specific_m.vue?vue&type=script&lang=js&"
import style0 from "./Specific_m.vue?vue&type=style&index=0&id=4d7be5f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7be5f8",
  null
  
)

export default component.exports